module.exports = __webpack_public_path__ + "static/media/icon_shopping_bag.3231458c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Icons/icon_shopping_bag.svg
// module id = 1518
// module chunks = 0